import React, { useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Mensaje } from "../components/mensajes";
import { Loader, Dimmer } from "semantic-ui-react";
import useTable from "../components/useTable";
import { TableBody, TableRow, TableCell } from "@material-ui/core";
import axios from "axios";

const CatalogoPersona = (props) => {
  const op = require("../../public/modulos/datos");
  const token = sessionStorage.getItem("jwtToken");

  const btnAcepta = useRef();
  const btnCancela = useRef();
  const txtPersona = useRef([]);
  const txtBuscar = useRef();
  const [activate, setActivate] = useState(false);
  const [records, setRecords] = useState([]);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });
  const [values, setValues] = useState({
    cedPer: "",
    nomPer: "",
    apePer: "",
    correoPer: "",
    tlf1Per: "",
    tlf2Per: "",
    fnacPer: "",
    nacPer: "",
    sexoPer: "",
    direPer: ""
  });

  const headCells = [
    { label: "CÉDULA", textAlign: "center" },
    { label: "NOMBRES", textAlign: "center" },
    { label: "APELLIDOS", textAlign: "center" },
  ];


  const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
    useTable(records, headCells, filterFn);

  const handleSearch = (e) => {
    let target = e.target;

    setFilterFn({
      fn: (items) => {
        if (target.value === "") {
          return items;
        } else {
          return items.filter((x) => {
            if (
              (x.nacionalidad + x.cedula)
                .toLowerCase()
                .includes(target.value) ||
              x.apellidos.toLowerCase().includes(target.value.toLowerCase()) ||
              x.nombres.toLowerCase().includes(target.value.toLowerCase())
            ) {
              return x;
            }
          });
        }
      },
    });
  };

  const seleccionarPersonasTodas = () => {
    let endpoint = `${op.conexion}/api/catalogo/personas`;

    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          setActivate(false);
          let perso = [];
          for (let i = 0; i < response.data.length; i++) {
            perso.push({
              cedula: response.data[i].cedula,
              nombres: response.data[i].nombres,
              apellidos: response.data[i].apellidos,
              correoe: response.data[i].correoe,
              tlf1: response.data[i].tlf1,
              tlf2: response.data[i].tlf2,
              fnacimiento: response.data[i].fnacimiento,
              nacionalidad: response.data[i].nacionalidad,
              sexo: response.data[i].sexo,
              direccion: response.data[i].direccion,
            });
          }
          setRecords(perso);
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: "error al cargar los registros",
          icono: "error",
        });
        setActivate(false);
      });
  };

  const blanquear = () => {
    setActivate(false);
    setRecords([]);
    setFilterFn({
      fn: (items) => {
        return items;
      },
    });
    setValues({
      cedPer: "",
      nomPer: "",
      apePer: "",
      correoPer: "",
      tlf1Per: "",
      tlf2Per: "",
      fnacPer: "",
      nacPer: "",
      sexoPer: "",
      direPer: ""
    });
  };

  const cancelar = () => {
    blanquear();
    props.onHideCancelaCatPer();
  };

  const seleccionarPersona = () => {
    blanquear();
    props.onHideAceptaCatPer(values);
  };

  const seleccionarFila = (item) => (e) => {
    e.preventDefault();

    setValues({
      cedPer: item.cedula,
      nomPer: item.nombres,
      apePer: item.apellidos,
      correoPer: item.correoe,
      tlf1Per: item.tlf1,
      tlf2Per: item.tlf2,
      fnacPer: item.fnacimiento,
      nacPer: item.nacionalidad,
      sexoPer: item.sexo,
      direPer: item.direccion
    });
    btnAcepta.current.focus();
  };


  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
      backdrop="static"
      keyboard={false}
      onShow={() => {
        seleccionarPersonasTodas();
        txtBuscar.current.focus();
      }}
    >
      <Modal.Header className="azulGradiant2 header-modal">
        <div className="fw-bold text-light">
          <h3>Seleccionar Persona</h3>
        </div>
        <button
          ref={btnCancela}
          className="bg-transparent"
          style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }}
          onClick={cancelar}
        >
          <i className="far fa-window-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body>
        <Mensaje
          mensaje={mensaje}
          onHide={() =>
            setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" })
          }
        />
        <Dimmer active={activate} inverted>
          <Loader inverted>Cargando...</Loader>
        </Dimmer>
        <div className="col-md-12" style={{ marginBottom: "10px" }}>
          <div className="row">
            <div className="input-group col-md-6 input-group-sm mb-3">
              <input
                type="text"
                onChange={handleSearch}
                className="form-control text-uppercase"
                ref={txtBuscar}
              />
              <button
                className="btn btn-info"
                style={{ pointerEvents: "none" }}
              >
                <i className="fa fa-search"></i>
              </button>
            </div>
          </div>
        </div>
        <div className="col-md-12" style={{ margin: "auto" }}>
          <TblContainer>
            <TblHead />

            <TableBody>
              {records &&
                recordsAfterPagingAndSorting().map((item, index) => (
                  <TableRow
                    key={index}
                    style={{
                      padding: "0",
                      cursor: "pointer",
                      background:
                        values.cedPer === item.cedula
                          ? "lightskyblue"
                          : "white",
                    }}
                    onClick={seleccionarFila(item)}
                  >
                    <TableCell className="py-2 text-center">
                      {item.nacionalidad + item.cedula}
                    </TableCell>
                    <TableCell className="py-2 text-start">
                      {item.nombres}
                    </TableCell>
                    <TableCell className="py-2 text-start">
                      {item.apellidos}
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </TblContainer>
          <TblPagination />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          ref={btnAcepta}
          className="btn btn-sm btn-success rounded-pill"
          style={{ margin: "5px" }}
          onClick={seleccionarPersona}
        >
          <i className="fas fa-check-circle"> Aceptar</i>{" "}
        </button>
        <button
          ref={btnCancela}
          onClick={cancelar}
          className="btn btn-sm btn-danger rounded-pill"
        >
          <i className="fas fa-window-close"> Cancelar</i>
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default CatalogoPersona;



// WEBPACK FOOTER //
// ./src/catalogos/catalogoPersona.js